export const networkConstraints = {
    id: {
        type: "string",
    },
    name: {
        type: "string",
        presence: true,
    },
};
